import { useCallback, useState } from "react";
import { Button } from "components/Button";
import { Icons } from "components/Icons";
import { Image } from "components/Image";
import { Input } from "components/Input";
import { Body, Header, TableContent } from "components/Table/style";
import { Card, CardBody, CardHeader, Col, Row } from "styles";

export function Environment({ preNecropsy, setPreNecropsy, config }) {
  const [info, setInfo] = useState(null);

  const getLabel = useCallback(
    (label, param) => (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>{label}</span>
        <Icons
          type="question"
          color="#009870"
          size={18}
          onClick={() =>
            setInfo({
              label,
              options: config.filter(({ key }) => key === param),
            })
          }
        />
      </div>
    ),
    [config]
  );

  return info ? (
    <Card style={{ height: "100%", marginBottom: "15px" }}>
      <CardHeader style={{ justifyContent: "space-between" }}>
        <strong>
          <i className="far fa-question-circle" /> &nbsp;
          {info.label}
        </strong>
        <Button
          color="white"
          bg="default"
          border="default"
          onClick={() => setInfo(null)}
          size="sm"
        >
          Voltar
        </Button>
      </CardHeader>
      <CardBody>
        <TableContent>
          <Header>
            <tr>
              <th style={{ width: "100px" }}>Score</th>
              <th>Descrição</th>
              <th style={{ width: "500px" }}>Imagem</th>
            </tr>
          </Header>
          <Body>
            {info.options.map((item) => (
              <tr key={item._id}>
                <td>
                  <span>
                    <b>{item.score}</b>
                  </span>
                </td>
                <td>{item.description}</td>
                <td>
                  <Image
                    className="img-fluid"
                    src={`https://zenbytes-public.sfo2.digitaloceanspaces.com/mcassab/necropsy-${item.key.replace(
                      /\./g,
                      "-"
                    )}-${item._id}.${item.extention}`}
                  />
                </td>
              </tr>
            ))}
          </Body>
        </TableContent>
      </CardBody>
    </Card>
  ) : (
    <>
      <Row>
        <Col>
          <Input
            item={preNecropsy}
            setItem={setPreNecropsy}
            params="environment.externalCleaning"
            type="select"
            placeholder="Selecione uma Opção"
            label={getLabel(
              "Limpeza Externa",
              "environment.hbExternalCleaning"
            )}
            options={config
              .filter(({ key }) => key === "environment.hbExternalCleaning")
              .map(({ score }) => ({ value: score }))}
          />
        </Col>
        <Col>
          <Input
            item={preNecropsy}
            setItem={setPreNecropsy}
            params="environment.internalCleaning"
            type="select"
            placeholder="Selecione uma Opção"
            label={getLabel(
              "Limpeza Interna",
              "environment.hbInternalCleaning"
            )}
            options={config
              .filter(({ key }) => key === "environment.hbInternalCleaning")
              .map(({ score }) => ({ value: score }))}
          />
        </Col>
        <Col>
          <Input
            item={preNecropsy}
            setItem={setPreNecropsy}
            params="environment.ventilationSystem"
            type="select"
            placeholder="Selecione uma Opção"
            label={getLabel(
              "Sistema de Ventilação",
              "environment.hbVentilationSystem"
            )}
            options={config
              .filter(({ key }) => key === "environment.hbVentilationSystem")
              .map(({ score }) => ({ value: score }))}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            item={preNecropsy}
            setItem={setPreNecropsy}
            params="environment.luxLighting"
            type="select"
            placeholder="Selecione uma Opção"
            label={getLabel("Iluminação Lux", "environment.hbLuxLighting")}
            options={config
              .filter(({ key }) => key === "environment.hbLuxLighting")
              .map(({ score }) => ({ value: score }))}
          />
        </Col>

        <Col>
          <Input
            item={preNecropsy}
            setItem={setPreNecropsy}
            params="environment.footbathPresence"
            type="select"
            placeholder="Selecione uma Opção"
            label={getLabel(
              "Presença Pediluvio",
              "environment.hbFootbathPresence"
            )}
            options={config
              .filter(({ key }) => key === "environment.hbFootbathPresence")
              .map(({ score }) => ({ value: score }))}
          />
        </Col>
        <Col>
          <Input
            item={preNecropsy}
            setItem={setPreNecropsy}
            params="environment.exclusiveFootwearUse"
            type="select"
            placeholder="Selecione uma Opção"
            label={getLabel(
              "Uso calçado Exclusivo",
              "environment.hbExclusiveFootwearUse"
            )}
            options={config
              .filter(({ key }) => key === "environment.hbExclusiveFootwearUse")
              .map(({ score }) => ({ value: score }))}
          />
        </Col>
      </Row>
    </>
  );
}
